import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const VemmoIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-7.6 0 27 12.5"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m12.5016 0c.5156.848438.7453 1.72031.7453 2.82656 0 3.52032-3.0047 8.09534-5.4469 11.30624h-5.56875l-2.23125-13.359362 4.87969-.464063 1.18594 9.506255c1.10156-1.80001 2.46562-4.62657 2.46562-6.54844 0-1.05469-.18281-1.77188-.46406-2.362503z"
        fill={color}
      />
    </Svg>
  )
}

export default VemmoIconSvg
